import React from "react";

import HomeUI from "../../ui/homeUI/_index";

const UserListPage = () => {
  return (
    <HomeUI />
  )
}

export default UserListPage;
